import VSelect from './VSelect';

VSelect.install = function install(Vue) {
  Vue.component(VSelect.name, VSelect);
};

export default VSelect;


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VSelect/index.js
// module id = +1ch
// module chunks = 0